function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { SimpleContainer, CssContainer } from "../../components/container";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import AudienceGrid from "../../components/audience-grid";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import { Button } from '@progress/kendo-react-buttons';
import Query from "../../functions/query";
import ServiceFactory from '../../service';
import ManageDataTabs from '../../components/manage-data-tabs';
import { manageDataLegacyHere } from '../../functions/tenant-features';
import DataShell, { Btn } from '../manage-data/shell';
import { RowMenu, DlCard, DlFoot, DlPager, fmtInt, updatedLabel } from '../manage-product/dl-kit';

/*
 * Audiences tab — manual create/rename/delete/add-member added per PlunkDocs
 * specs/mockups/manage-data-manual-edit.html §2 (endpoints built 2026-08-02):
 *   POST /v1/audience/create {name}   create empty (409 = name conflict/system)
 *   PUT  /v1/audience/{id}   {name}   rename (409 on system)
 *   DELETE /v1/audience/{id}          delete (removes memberships)
 *   POST /v1/audience + x-audience-id + [{email,…}]   add member (the existing
 *     bulk-contacts endpoint — a single member is a one-element list; person
 *     resolution matches the Audience feed: email match → existing, else create)
 * Delete warns when the audience is an Audience-feed target (feeds reference
 * the target by NAME in referenceId — guard is UI-side for now).
 * Ids exceed 2^53 (JSONbig opaques) — only ever String(id) into URLs/headers.
 */

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15,23,35,.45)',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
const boxStyle = {
  background: '#fff',
  borderRadius: '10px',
  width: '440px',
  maxWidth: '92%',
  padding: '20px 22px',
  boxShadow: '0 12px 40px rgba(0,0,0,.25)'
};
const inp = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '7px 9px',
  border: '1px solid #d5dbe3',
  borderRadius: '6px',
  fontSize: '13px'
};
const lbl = {
  fontSize: '12px',
  fontWeight: 600,
  display: 'block',
  marginBottom: '10px'
};
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    // Outside-click close. React's synthetic stopPropagation can't stop a
    // sibling listener on the SAME document node, so the opening click also
    // reaches this handler — the ref containment check is what keeps the
    // menu from closing in the same click that opened it.
    _defineProperty(this, "closeMenu", e => {
      if (this.menuWrap && e && this.menuWrap.contains(e.target)) return;
      if (this.state.menu) this.setState({
        menu: false
      });
    });
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "close", () => this.setState({
      modal: null,
      target: null,
      name: '',
      error: '',
      busy: false,
      member: {
        email: '',
        firstName: '',
        lastName: '',
        phone: ''
      }
    }));
    _defineProperty(this, "createEmpty", async () => {
      const name = this.state.name.trim();
      if (!name) {
        this.setState({
          error: 'Name is required.'
        });
        return;
      }
      this.setState({
        busy: true,
        error: ''
      });
      try {
        const Service = ServiceFactory.getType('/audience/create', 'audience');
        await new Service().postAsync({
          name
        });
        this.toast(`Created “${name}” — add members any time.`);
        this.close();
        this.refresh();
      } catch (err) {
        this.setState({
          busy: false,
          error: err.statusCode === 409 ? `“${name}” already exists (or is a reserved system name).` : err.message || 'Create failed.'
        });
      }
    });
    _defineProperty(this, "rename", async () => {
      const name = this.state.name.trim();
      const row = this.state.target;
      if (!name || !row) {
        this.setState({
          error: 'Name is required.'
        });
        return;
      }
      this.setState({
        busy: true,
        error: ''
      });
      try {
        const Service = ServiceFactory.getType(`/audience/${String(row.id)}`, 'audience');
        await new Service().putAsync({
          name
        });
        this.toast(`Renamed to “${name}”.`);
        this.close();
        this.refresh();
      } catch (err) {
        this.setState({
          busy: false,
          error: err.statusCode === 409 ? `“${name}” is taken or reserved.` : err.message || 'Rename failed.'
        });
      }
    });
    _defineProperty(this, "remove", async () => {
      const row = this.state.target;
      if (!row) return;
      this.setState({
        busy: true,
        error: ''
      });
      try {
        const Service = ServiceFactory.getType(`/audience/${String(row.id)}`, 'audience');
        const r = await new Service().deleteAsync();
        const n = r && r.membersRemoved !== undefined ? ` (${r.membersRemoved} memberships removed)` : '';
        this.toast(`Deleted “${row.name}”${n}.`);
        this.close();
        this.refresh();
      } catch (err) {
        this.setState({
          busy: false,
          error: err.message || 'Delete failed.'
        });
      }
    });
    _defineProperty(this, "addMember", async () => {
      const row = this.state.target;
      const m = this.state.member;
      const email = m.email.trim();
      if (!row) return;
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        this.setState({
          error: 'A valid email is required.'
        });
        return;
      }
      this.setState({
        busy: true,
        error: ''
      });
      try {
        const Service = ServiceFactory.getType('/audience', 'audience');
        // Per-call header — getType mints a fresh class, so appending to
        // its static headers can't leak into other requests.
        Service.headers = [...(Service.headers || []), 'x-audience-id:' + String(row.id)];
        // ManagedAudienceContact fields — emailAddress/phoneNumber, not email/phone.
        const body = [{
          emailAddress: email
        }];
        if (m.firstName.trim()) body[0].firstName = m.firstName.trim();
        if (m.lastName.trim()) body[0].lastName = m.lastName.trim();
        if (m.phone.trim()) body[0].phoneNumber = m.phone.trim();
        await new Service().postAsync(body);
        this.toast(`Added ${email} to “${row.name}”.`);
        this.close();
        this.refresh();
      } catch (err) {
        this.setState({
          busy: false,
          error: err.message || 'Add member failed.'
        });
      }
    });
    this.state = {
      menu: false,
      modal: null,
      // 'create' | 'rename' | 'delete' | 'member'
      target: null,
      // audience row for rename/delete/member
      name: '',
      member: {
        email: '',
        firstName: '',
        lastName: '',
        phone: ''
      },
      feedTargets: null,
      // audience NAMES targeted by Audience feeds (lazy)
      busy: false,
      error: ''
    };
  }
  componentDidMount() {
    publishSearch('Audiences');
    publishEvent('reset-search', {});
    document.addEventListener('click', this.closeMenu);
    if (!manageDataLegacyHere()) this.loadFeedTargets(); // kit: "How people get in" names feed-filled lists
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.closeMenu);
  }
  toast(msg) {
    var t = document.querySelector("paper-toast");
    if (t) t.show(msg);
  }
  refresh() {
    if (this.props.onRefresh) this.props.onRefresh();
  }
  // Audience-feed targets, for the delete warning (feeds store the target
  // audience NAME in referenceId).
  loadFeedTargets() {
    if (this.state.feedTargets !== null) return;
    this.setState({
      feedTargets: []
    });
    const Service = ServiceFactory.getType('/data-feeds', 'product');
    new Service().getAsync().then(r => {
      const rows = Array.isArray(r) ? r : r && r.items || [];
      const names = rows.filter(f => f.provider === 'Audience' && f.referenceId).map(f => f.referenceId);
      this.setState({
        feedTargets: names
      });
    }).catch(() => {/* warning stays generic */});
  }
  renderModal() {
    const {
      modal,
      target,
      name,
      member,
      busy,
      error,
      feedTargets
    } = this.state;
    if (!modal) return null;
    const stop = e => {
      if (e.target === e.currentTarget && !busy) this.close();
    };
    const err = error && /*#__PURE__*/React.createElement("p", {
      style: {
        color: '#c0392b',
        fontSize: '12px',
        margin: '4px 0 8px'
      }
    }, error);
    if (modal === 'create') return /*#__PURE__*/React.createElement("div", {
      style: overlayStyle,
      onClick: stop
    }, /*#__PURE__*/React.createElement("div", {
      style: boxStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label",
      style: {
        fontSize: '16px',
        marginBottom: '10px'
      }
    }, "New empty audience"), /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Name *", /*#__PURE__*/React.createElement("input", {
      style: inp,
      autoFocus: true,
      value: name,
      onChange: e => this.setState({
        name: e.target.value,
        error: ''
      }),
      onKeyDown: e => {
        if (e.key === 'Enter') this.createEmpty();
        if (e.key === 'Escape') this.close();
      }
    })), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: '0 0 12px'
      }
    }, "Name it now, add members any time \u2014 one at a time here, by file upload, or with a scheduled Audience feed."), err, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: this.close
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy,
      onClick: this.createEmpty
    }, busy ? 'Creating…' : 'Create'))));
    if (modal === 'rename') return /*#__PURE__*/React.createElement("div", {
      style: overlayStyle,
      onClick: stop
    }, /*#__PURE__*/React.createElement("div", {
      style: boxStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label",
      style: {
        fontSize: '16px',
        marginBottom: '10px'
      }
    }, "Rename \u2014 ", target.name), /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "New name *", /*#__PURE__*/React.createElement("input", {
      style: inp,
      autoFocus: true,
      value: name,
      onChange: e => this.setState({
        name: e.target.value,
        error: ''
      }),
      onKeyDown: e => {
        if (e.key === 'Enter') this.rename();
        if (e.key === 'Escape') this.close();
      }
    })), err, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: this.close
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy,
      onClick: this.rename
    }, busy ? 'Saving…' : 'Save'))));
    if (modal === 'delete') {
      const isFeedTarget = (feedTargets || []).includes(target.name);
      return /*#__PURE__*/React.createElement("div", {
        style: overlayStyle,
        onClick: stop
      }, /*#__PURE__*/React.createElement("div", {
        style: boxStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "heading-label",
        style: {
          fontSize: '16px',
          marginBottom: '8px'
        }
      }, "Delete audience"), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: '13px',
          margin: '0 0 6px'
        }
      }, "Delete ", /*#__PURE__*/React.createElement("b", null, target.name), " and its ", /*#__PURE__*/React.createElement("b", null, target.total || 0), " memberships? Contacts themselves are kept."), isFeedTarget && /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: '12px',
          color: '#c0392b',
          margin: '0 0 6px'
        }
      }, "\u26A0 This audience is the target of a scheduled Audience feed \u2014 the feed will fail until it's retargeted (Feeds tab)."), /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: '0 0 14px'
        }
      }, "Campaigns targeting this audience keep running but lose the audience grouping."), err, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '8px'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: busy,
        onClick: this.close
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        themeColor: "error",
        disabled: busy,
        onClick: this.remove
      }, busy ? 'Deleting…' : 'Delete audience'))));
    }
    if (modal === 'member') return /*#__PURE__*/React.createElement("div", {
      style: overlayStyle,
      onClick: stop
    }, /*#__PURE__*/React.createElement("div", {
      style: boxStyle
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '18px',
        fontWeight: 700,
        color: '#232020',
        marginBottom: '14px'
      }
    }, "Add a person to ", target.name), /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Email *", /*#__PURE__*/React.createElement("input", {
      style: inp,
      autoFocus: true,
      value: member.email,
      placeholder: "name@company.com",
      onChange: e => this.setState({
        member: {
          ...member,
          email: e.target.value
        },
        error: ''
      }),
      onKeyDown: e => {
        if (e.key === 'Enter') this.addMember();
        if (e.key === 'Escape') this.close();
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px'
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "First name", /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: member.firstName,
      onChange: e => this.setState({
        member: {
          ...member,
          firstName: e.target.value
        }
      })
    })), /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Last name", /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: member.lastName,
      onChange: e => this.setState({
        member: {
          ...member,
          lastName: e.target.value
        }
      })
    }))), /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Phone", /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: member.phone,
      onChange: e => this.setState({
        member: {
          ...member,
          phone: e.target.value
        }
      })
    })), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: '0 0 12px'
      }
    }, "If this email is already in Plunk, that person is added to the list. Otherwise a new contact is created."), err, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: this.close
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy,
      onClick: this.addMember
    }, busy ? 'Adding…' : 'Add to list'))));
    return null;
  }

  // How people get into a list, in plain words (dataflow Audiences mockup).
  howIn(row) {
    const n = String(row.name || '').toLowerCase();
    if (n === 'all contacts') return 'Everyone Plunk knows about';
    if (n === 'customers') return 'People who have bought';
    if ((this.state.feedTargets || []).includes(row.name)) return 'Filled by a scheduled feed, plus people you add';
    const prov = String(row.provider || '').trim();
    if (prov && !/^(managed|upload|uploaded|file|csv|manual|plunk)$/i.test(prov)) return `From ${prov}, plus people you add`;
    return 'Uploaded list, plus people you add';
  }
  renderKit(baseUrl, refreshUrl, data) {
    const rows = Array.isArray(data) ? data : [];
    const isSystem = row => ['all contacts', 'customers'].includes(String(row.name || '').toLowerCase());
    const open = row => this.gotoPage('/Contacts/Audience/' + String(row.name || '').replace(/ /g, '@'));
    const total = this.props.pagination && this.props.pagination.count != null ? Number(this.props.pagination.count) : rows.length;
    const actions = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
      onClick: () => this.gotoPage('/Audience/Create')
    }, "Upload a list"), /*#__PURE__*/React.createElement(Btn, {
      primary: true,
      onClick: () => this.setState({
        modal: 'create',
        name: ''
      })
    }, "New audience"));
    return /*#__PURE__*/React.createElement(DataShell, {
      active: "/Audience",
      subtitle: "Where your data comes from and how Plunk uses it",
      actions: actions
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-grid dl-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dl-strip"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dl-dot info"
    }), /*#__PURE__*/React.createElement("span", {
      className: "dl-grow"
    }, "This is where lists come in. To see who is on a list, how it's growing and who can be emailed, open it in Customers \u203A Audiences."), /*#__PURE__*/React.createElement("a", {
      onClick: () => this.gotoPage('/Audiences')
    }, "Go to Audiences")), /*#__PURE__*/React.createElement(DlCard, {
      title: "Your lists",
      hint: `${fmtInt(total)} ${total === 1 ? 'list' : 'lists'}`
    }, rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table dl-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "List"), /*#__PURE__*/React.createElement("th", null, "How people get in"), /*#__PURE__*/React.createElement("th", {
      className: "num"
    }, "People"), /*#__PURE__*/React.createElement("th", null, "Updated"), /*#__PURE__*/React.createElement("th", {
      className: "dl-act",
      "aria-label": "Actions"
    }))), /*#__PURE__*/React.createElement("tbody", null, rows.map(row => {
      const sys = isSystem(row);
      return /*#__PURE__*/React.createElement("tr", {
        key: String(row.id)
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        className: "dl-name",
        onClick: () => open(row)
      }, row.name || 'Untitled list'), sys ? /*#__PURE__*/React.createElement("span", {
        className: "dl-chip grey"
      }, "Automatic") : null), /*#__PURE__*/React.createElement("td", {
        className: "dl-muted"
      }, this.howIn(row)), /*#__PURE__*/React.createElement("td", {
        className: "num"
      }, fmtInt(row.total)), /*#__PURE__*/React.createElement("td", null, updatedLabel(row.lastRefreshDate)), /*#__PURE__*/React.createElement("td", {
        className: "dl-act"
      }, /*#__PURE__*/React.createElement(RowMenu, {
        label: row.name || 'list',
        items: sys ? [{
          label: 'Open',
          onClick: () => open(row)
        }] : [{
          label: 'Open',
          onClick: () => open(row)
        }, {
          label: 'Add a person',
          onClick: () => this.setState({
            modal: 'member',
            target: row,
            error: ''
          })
        }, {
          label: 'Upload more',
          onClick: () => this.gotoPage('/Audience/Create?name=' + encodeURIComponent(row.name || ''))
        }, {
          label: 'Rename',
          onClick: () => this.setState({
            modal: 'rename',
            target: row,
            name: row.name,
            error: ''
          })
        }, {
          label: 'Delete',
          danger: true,
          onClick: () => {
            this.loadFeedTargets();
            this.setState({
              modal: 'delete',
              target: row,
              error: ''
            });
          }
        }]
      })));
    })))) : /*#__PURE__*/React.createElement("p", {
      className: "dl-empty"
    }, "No lists yet. Upload a list or start a new audience."), /*#__PURE__*/React.createElement(DlFoot, {
      right: /*#__PURE__*/React.createElement(DlPager, {
        pagination: this.props.pagination,
        onGo: this.onPageRequest,
        noun: "lists"
      })
    }, "Automatic lists keep themselves up to date and can't be renamed or deleted. The \xB7\xB7\xB7 menu has Add a person, Upload more, Rename and Delete."))), this.renderModal());
  }
  render() {
    var baseUrl = '/Audience';
    var refreshUrl = '/Audience';
    var data = this.props.data;
    if (!manageDataLegacyHere()) return this.renderKit(baseUrl, refreshUrl, data);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view"
    }, /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Manage Data"), /*#__PURE__*/React.createElement("span", {
      style: {
        position: 'relative',
        display: 'inline-block'
      },
      ref: el => {
        this.menuWrap = el;
      }
    }, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: () => this.setState({
        menu: !this.state.menu
      })
    }, "Create Audience ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "arrow_drop_down")), this.state.menu && /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        right: 0,
        top: '110%',
        zIndex: 100,
        background: '#fff',
        border: '1px solid #d5dbe3',
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0,0,0,.15)',
        minWidth: '240px',
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '10px 14px',
        cursor: 'pointer',
        borderBottom: '1px solid #eef1f5'
      },
      onClick: () => this.setState({
        menu: false,
        modal: 'create',
        name: ''
      })
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '13px',
        fontWeight: 600
      }
    }, "New empty audience"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '11px',
        color: '#6b7686'
      }
    }, "Name it now, add members any time")), /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '10px 14px',
        cursor: 'pointer'
      },
      onClick: () => this.gotoPage('/Audience/Create')
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '13px',
        fontWeight: 600
      }
    }, "Import from file\u2026"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '11px',
        color: '#6b7686'
      }
    }, "The 3-step upload flow"))))), /*#__PURE__*/React.createElement(ManageDataTabs, {
      active: "/Audience"
    }), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: '0 0 4px'
      }
    }, "Create an audience here, then import members by uploading a file (Create Audience) or with a scheduled Audience feed (Feeds tab \u2014 pick the target audience there). System audiences are managed automatically and aren't import targets.")), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(AudienceGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: data,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest,
      onAddMember: row => this.setState({
        modal: 'member',
        target: row,
        error: ''
      }),
      onRename: row => this.setState({
        modal: 'rename',
        target: row,
        name: row.name,
        error: ''
      }),
      onDelete: row => {
        this.loadFeedTargets();
        this.setState({
          modal: 'delete',
          target: row,
          error: ''
        });
      }
    })), this.renderModal());
  }
}
export class AudienceViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
    _defineProperty(this, "refresh", () => {
      this.fetchData();
    });
  }
  async fetchData() {
    let query = this.queryParams;
    let page = this.page;
    var api = '/audience';
    var Service = ServiceFactory.getType(api, 'audience');
    var service = new Service();
    var baseUrl = '/Audience';
    try {
      // The kit list shows up to 50 lists a page; the legacy grid keeps 10.
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: manageDataLegacyHere() ? 10 : 50
      }).orderBy(query.get('$orderBy')).orderByDesc(query.get('$orderByDesc')).getAsync();
      this.data = data.items;
      this.pagination = data.pagination;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params,
        onRefresh: this.refresh
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  AudienceViewComponent
};